import { cn } from '../lib/cn'

interface PillProps {
  children: React.ReactNode
  className?: string
  delay?: number
  size?: 'sm' | 'md' | 'lg'
}

export function Pill({ children, className, delay = 0, size = 'md' }: PillProps) {
  const sizeClasses = {
    sm: 'px-2 py-1 rounded-[6px]',
    md: 'px-4 py-2 rounded-[10px]',
    lg: 'px-6 py-3 rounded-[12px]'
  }

  const textSizeClasses = {
    sm: 'text-body-small',
    md: 'text-body-mobile',
    lg: 'text-body'
  }

  return (
    <div
      className={cn(
        'inline-flex items-center',
        'backdrop-blur-sm w-fit',
        'max-w-full',
        sizeClasses[size],
        className
      )}
      style={{
        backgroundColor: 'rgba(250, 249, 245, 1)',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.25)',
      }}
    >
      <span className={cn(textSizeClasses[size], 'font-medium tracking-[-0.015em]')} style={{ color: 'var(--night)' }}>
        {children}
      </span>
    </div>
  )
}

